// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.journal-card {
  border-radius: 10px;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 10px 0px rgba(129, 90, 165, 0.1490196078);
}

.class-selector {
  margin: 0 40px 40px;
  justify-content: space-between;
}
.class-selector .edit {
  opacity: 1;
  transition: opacity 0.5s;
}
.class-selector .edit.true {
  opacity: 0;
}
.class-selector button {
  font-family: "DM Sans", sans-serif !important;
  transition: all 0.5s;
  height: 31px;
  padding: 0 10px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);
  color: white;
  text-align: center;
  font-family: Rounded Mplus 1c Bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-right: 10px;
  background-color: #74b8de;
}
.class-selector button:hover {
  box-shadow: 0px 10px 10px 0px rgba(60, 44, 74, 0.15);
}
.class-selector select {
  height: 31px;
  border-radius: 10px;
  background: #74b8de;
  color: #fff;
  padding-left: 10px;
  font-family: Rounded Mplus 1c Bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16.5px;
  box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);
}
.class-selector select::after {
  color: #fff;
}
.class-selector select option {
  /* for IE */
  color: #fff !important;
}

.table-header {
  display: flex;
  width: 100%;
  margin: 40px;
}
.table-header .title {
  color: #414141;
  font-family: Rounded Mplus 1c Bold;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  /* 68.75% */
  letter-spacing: -0.25px;
  margin-right: 50px;
}

.hint {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 40px;
  transition: opacity 0.5s;
  opacity: 0;
}
.hint.true {
  opacity: 1;
}
.hint span {
  color: #414141;
  font-family: Rounded Mplus 1c Bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16.5px;
  /* 137.5% */
  letter-spacing: -0.25px;
  margin-left: 20px;
}

@media screen and (max-width: 1090px) {
  .journal-card .flex {
    flex-direction: column !important;
    margin-bottom: 20px;
    align-items: center;
    justify-content: center;
  }
  .journal-card .flex .hint {
    flex-direction: row;
    margin-left: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/admin/journal/journal.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,6DAAA;AACF;;AAEA;EACE,mBAAA;EAEA,8BAAA;AAAF;AACE;EACE,UAAA;EACA,wBAAA;AACJ;AAAI;EACE,UAAA;AAEN;AACE;EACE,6CAAA;EACA,oBAAA;EAEA,YAAA;EACA,eAAA;EAEA,mBAAA;EACA,gBAAA;EACA,kDAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;AAEI;EACE,oDAAA;AAAN;AAIE;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EAEA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kDAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAMI;EACE,WAAA;EACA,sBAAA;AAJN;;AASA;EACE,aAAA;EACA,WAAA;EACA,YAAA;AANF;AAQE;EACE,cAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EAEA,WAAA;EACA,uBAAA;EACA,kBAAA;AAPJ;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;AARF;AAUE;EACE,UAAA;AARJ;AAWE;EACE,cAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AATJ;;AAaA;EACE;IACE,iCAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;EAVF;EAYE;IACE,mBAAA;IACA,iBAAA;EAVJ;AACF","sourcesContent":[".journal-card {\r\n  border-radius: 10px;\r\n  background: #f9f9f9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0px 4px 10px 0px #815aa526;\r\n}\r\n\r\n.class-selector {\r\n  margin: 0 40px 40px;\r\n  // margin-bottom: 40px;\r\n  justify-content: space-between;\r\n  .edit {\r\n    opacity: 1;\r\n    transition: opacity 0.5s;\r\n    &.true {\r\n      opacity: 0;\r\n    }\r\n  }\r\n  button {\r\n    font-family: \"DM Sans\", sans-serif !important;\r\n    transition: all 0.5s;\r\n    font-size: 16px;\r\n    height: 31px;\r\n    padding: 0 10px;\r\n    // background: white;\r\n    border-radius: 10px;\r\n    background: #fff;\r\n    box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);\r\n    color: white;\r\n    text-align: center;\r\n    font-family: Rounded Mplus 1c Bold;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n    margin-right: 10px;\r\n    background-color: #74b8de;\r\n\r\n    &:hover {\r\n      box-shadow: 0px 10px 10px 0px rgba(60, 44, 74, 0.15);\r\n    }\r\n  }\r\n\r\n  select {\r\n    height: 31px;\r\n    border-radius: 10px;\r\n    background: #74b8de;\r\n\r\n    color: #fff;\r\n    padding-left: 10px;\r\n    font-family: Rounded Mplus 1c Bold;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 16.5px;\r\n    box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);\r\n\r\n    &::after {\r\n      color: #fff;\r\n    }\r\n\r\n    option {\r\n      /* for IE */\r\n      color: #fff !important;\r\n    }\r\n  }\r\n}\r\n\r\n.table-header {\r\n  display: flex;\r\n  width: 100%;\r\n  margin: 40px;\r\n\r\n  .title {\r\n    color: #414141;\r\n    font-family: Rounded Mplus 1c Bold;\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    // line-height: 0.5px;\r\n    /* 68.75% */\r\n    letter-spacing: -0.25px;\r\n    margin-right: 50px;\r\n  }\r\n}\r\n\r\n.hint {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-right: 40px;\r\n  transition: opacity 0.5s;\r\n  opacity: 0;\r\n\r\n  &.true {\r\n    opacity: 1;\r\n  }\r\n\r\n  span {\r\n    color: #414141;\r\n    font-family: Rounded Mplus 1c Bold;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 16.5px;\r\n    /* 137.5% */\r\n    letter-spacing: -0.25px;\r\n    margin-left: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: \"1090px\") {\r\n  .journal-card .flex {\r\n    flex-direction: column !important;\r\n    margin-bottom: 20px;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    .hint {\r\n      flex-direction: row;\r\n      margin-left: 20px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
